import MenuIcon from '@mui/icons-material/Menu';
import { Grid, IconButton, useMediaQuery } from '@mui/material';
import Drawer from '@mui/material/Drawer';
import classNames from 'classnames';
import { useUser } from 'contexts/userContext';
import { FC, useState } from 'react';
import { useLocation, useNavigate } from 'react-router';
import extendedTheme from 'styles/theme';

import SideNavForMobile from 'components/SideNavForMobile';

import theme from './theme.module.scss';

interface Tab {
  key: string;
  label: string;
  icon: any;
  route: string;
}

const Sidebar: FC<{ tabs: Tab[] }> = ({ tabs }) => {
  const isMobileScreen = useMediaQuery('(max-width:601px)');
  const [isDrawerMinimized, setIsDrawerMinimized] = useState(false);
  const drawersMinWidth = 60;
  const drawersMaxWidth = 270;
  const navigate = useNavigate();
  const location = useLocation();

  const { isAuthenticated, user } = useUser();

  if (isMobileScreen) {
    return !isDrawerMinimized ? (
      <div className={theme.navIcon}>
        <IconButton
          aria-label="hide"
          size="small"
          onClick={() => {
            setIsDrawerMinimized(!isDrawerMinimized);
          }}
          title={isDrawerMinimized ? 'Expand' : 'Collapse'}
        >
          <MenuIcon fontSize="medium" sx={{ color: 'black' }} />
        </IconButton>
      </div>
    ) : (
      <SideNavForMobile setIsDrawerMinimized={setIsDrawerMinimized} tabs={tabs} />
    );
  }
  return (
    <Drawer
      sx={{
        width: isDrawerMinimized ? drawersMinWidth : drawersMaxWidth,
        overflowX: 'hidden',
        transition: 'width .5s',
        zIndex: 100,
        flexShrink: 0,
        '& .MuiDrawer-paper': {
          width: isDrawerMinimized ? drawersMinWidth : drawersMaxWidth,
          boxSizing: 'border-box',
          transition: 'width .5s',
          borderRight: 'None',
          boxShadow: '0 16px 8px rgba(186, 186, 186, 0.5)',
        },
      }}
      variant="permanent"
      anchor="left"
    >
      <Grid container alignItems="center" justifyContent="center" pt={2.5} pb={1.5} width="100%">
        {isDrawerMinimized ? (
          <img
            src="https://www.woodkraft.com/wp-content/uploads/2021/09/favicon.png.png"
            height={30}
            width={30}
          />
        ) : (
          <img
            src="https://www.woodkraft.com/wp-content/uploads/2024/12/WK-E1.png"
            alt="wk logo"
            width={'60%'}
          />
        )}
      </Grid>
      <div className={theme.logoContainer}>
        <IconButton
          aria-label="hide"
          size="small"
          sx={{
            margin: '0px 12.5px',
          }}
          title={isDrawerMinimized ? 'Expand' : 'Collapse'}
          onClick={() => setIsDrawerMinimized(prev => !prev)}
        >
          <MenuIcon
            fontSize="medium"
            sx={{ color: !isDrawerMinimized ? extendedTheme.palette.secondary.main : '#000000' }}
          />
        </IconButton>
        <span className={theme.usernameContainer}>
          <b>{isAuthenticated ? user?.name : 'Not logged in'}</b>
        </span>
      </div>
      <div className={theme.tabContainer}>
        {tabs.map(tab => (
          <div
            className={classNames(
              theme.tab,
              location.pathname === tab.route ||
                (location.pathname.includes(tab.route) && tab.route !== '/') ||
                (tab.route === '/' && location.pathname === '/')
                ? theme.active
                : null
            )}
            key={tab.key}
            onClick={() => navigate(tab.route)}
          >
            <span className={theme.icon}>
              {{
                ...tab.icon,
                props: {
                  color:
                    location.pathname === tab.route ||
                    (location.pathname.includes(tab.route) && tab.route !== '/')
                      ? 'black'
                      : 'inherit',
                },
              }}
            </span>

            <span className={theme.label}>{tab.label}</span>
          </div>
        ))}
      </div>
    </Drawer>
  );
};

export default Sidebar;
